module.exports = __webpack_public_path__ + "img/login_bg.df528966.png";